import { render, staticRenderFns } from "./SecondCur.vue?vue&type=template&id=efb8a106&scoped=true&"
import script from "./SecondCur.vue?vue&type=script&lang=js&"
export * from "./SecondCur.vue?vue&type=script&lang=js&"
import style0 from "./SecondCur.vue?vue&type=style&index=0&id=efb8a106&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb8a106",
  null
  
)

export default component.exports